import Applicants from "./applicants";
import Referee from "./referees";
import portalSelection from "./portalSelection";
import Register from "./portalSelection/Register";
import ResearchAuthorities from "./researchAuthorities";
import Advisors from "./advisors";
import NewProposal from "./portalSelection/NewPropsal";

const modules = [
  {
    module: Applicants,
    path: "/applicantsportal",
    auth: true,
  },
  {
    module: Referee,
    path: "/referee",
    auth: true,
  },
  {
    module: ResearchAuthorities,
    path: "/researchauthorities",
    auth: true,
  },
  {
    module: Advisors,
    path: "/advisors",
    auth: true,
  },
  {
    module: Register,
    path: "/register",
    auth: false,
  },
  {
    module: NewProposal,
    path: "/newproposal",
    auth: true,
  },
  {
     module: portalSelection,
     path: "/",
     auth: true,
   },
];

export default modules;
